// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Types
import type { RootState, SearchBar } from "redux/types";
import { ResponseGpoSearch } from "interfaces/searchPage/osaSearch";

// Constants
import { defaultResultsQuery } from "constants/searchPage/results";

// Defaults
export const initialState: SearchBar = {
	isMobileSearch: false,
	suggestionsSearchResults: defaultResultsQuery,
	value: ""
};

// Slice
export const searchBarSlice = createSlice({
	name: "SEARCH_BAR",
	initialState,
	reducers: {
		setIsMobileSearch: (state, action: PayloadAction<boolean>) => {
			return { ...state, isMobileSearch: action.payload };
		},
		setSearchBarValue: (state, action: PayloadAction<string>) => {
			return { ...state, value: action.payload };
		},
		setSuggestionsSearchResults: (state, action: PayloadAction<ResponseGpoSearch>) => {
			return { ...state, suggestionsSearchResults: action.payload };
		},
		clearSuggestionsResults: (state) => {
			return { ...state, suggestionsSearchResults: defaultResultsQuery };
		}
	}
});

// Actions
export const { setIsMobileSearch, setSearchBarValue, setSuggestionsSearchResults, clearSuggestionsResults } = searchBarSlice.actions;

// Selector
export const isMobileSearchSelector = (state: RootState): boolean => state.searchBar.isMobileSearch;
export const searchBarValueSelector = (state: RootState): string => state.searchBar.value;
export const suggestionsSearchResultSelector = (state: RootState): ResponseGpoSearch => state.searchBar.suggestionsSearchResults;

// Reducers
export default searchBarSlice.reducer;
